import { useTranslation } from 'react-i18next';

/**
 * Returns the current i18n language code (fr/nl/en/es).
 * Used to pass `?lang=X` query param on public API calls
 * so the backend returns the translated version of content.
 */
export const useLang = () => {
  const { i18n } = useTranslation();
  const lang = (i18n.language || 'fr').toLowerCase().split('-')[0];
  return ['fr', 'nl', 'en', 'es'].includes(lang) ? lang : 'fr';
};

export default useLang;
